import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import Iconify from '../iconify';
import Logo from '../logo';

const guaranteeIcon = '/assets/icons/navbar/guarantee.svg'; // Replace with actual path

export default function OnTimeGuaranteeModal({ open, onClose }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      PaperProps={{
        sx: {
          borderRadius: 4,
          background: '#18314F',
          color: '#fff',
          p: 0,
          overflow: 'hidden',
        },
      }}
    >
      <Box sx={{ position: 'absolute', top: 16, right: 16, zIndex: 10 }}>
        <IconButton onClick={onClose} sx={{ color: '#fff' }}>
          <Iconify icon="ic:round-close" width={24} height={24} />
        </IconButton>
      </Box>
      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: 'center',
          p: 0,
          m: 0,
          minWidth: { md: 800 },
          minHeight: { md: 400 },
        }}
      >
        <Box sx={{ flex: 1, zIndex: 1, p: 3 }}>
          <Logo sx={{ width: 150, height: 70, mb: 2.5 }} />
          <Box sx={{ mb: 3 }}>
            <Box
              component="img"
              src={guaranteeIcon}
              alt="guarantee"
              sx={{ width: 60, height: 60, mb: 2 }}
            />

            <Typography variant="h3" sx={{ fontWeight: 600, mb: 2, color: '#fff' }}>
              On-Time Visa Guarantee
              <br />
              by tryvisa
            </Typography>
            <Typography sx={{ color: '#B3C2D1', mb: 2, fontSize: 16 }}>
              At tryvisa, we understand that timing is everything when it comes to travel.
              That&apos;s why we ensure your visa is processed accurately and on time.
            </Typography>
            <Typography sx={{ color: '#B3C2D1', fontSize: 16 }}>
              Whether it&apos;s a business trip or a dream vacation, we&apos;ve got your back with
              timely delivery, dedicated support, and 100% transparency.
              <br />
              Guaranteed. Reliable. tryvisa.
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            flex: 1,
            display: { xs: 'none', md: 'flex' },
            position: 'relative',
            height: '100%',
            margin: 0,
            padding: 0,
            overflow: 'hidden',
          }}
        >
          <Box
            component="img"
            src="/assets/illustrations/person.webp" // Replace with actual path
            alt="smiling man"
            sx={{
              height: '100%',
              width: '100%',
              margin: 0,
              padding: 0,
            }}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
}

OnTimeGuaranteeModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
